<template>
  <div id="map3decharts">
    <div id="lineChart" ref="lineChart"></div>
  </div>
</template>
<script>
import mapDataCq from "../assets/henan.json";

// import echarts from 'echarts'
// 导入echarts库以及地图扩展模块
import 'echarts/lib/chart/map';
import 'echarts/lib/component/geo';
import "echarts-gl" //3D地图插件
import bg from '../assets/bg.png'
export default {
  data() {
    return {
      mapDataCqG: mapDataCq,
      option:''
    };
  },
  mounted() {
    this.lineChart = this.$echarts.init(this.$refs.lineChart);
    this.$nextTick(() => {
      this.setLineChart(this.mapDataCqG);
    });
  },
  methods: {
    clearArea(){
      console.log();
      this.option.geo3D.regions = []
      this.setLineChart(this.mapDataCqG);

    },

    setLineChart(nval, mapColor) {
      this.$echarts.registerMap('map', nval);
      //3D地图旋转主要配置
      var viewControl = {
        // alpha: 78, // 上下旋转的角度
        // beta: 0, // 左右旋转的角度
        // panSensitivity: 3,
        // distance: 170,
        // rotateSensitivity: 0,
        // center:[0,0,10],
        // minAlpha: 5, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
        // maxAlpha: 100, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
        // minBeta: 25, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
        // maxBeta: 360, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
        // animation: true, // 是否开启动画。[ default: true ]
        // animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
        // animationEasingUpdate: "cubicInOut",// 过渡动画的缓动效果。[ default: cubicInOut ]
        // projection :'perspective',
        // maxDistance:170,
        // minDistance :170
        // autoRotate:true

        rotateSensitivity: 0,
        projection: 'orthographic',
        orthographicSize: 90, //控制地图大小
        maxOrthographicSize: 90,
        minOrthographicSize: 90,
        autoRotate: false,
        animation: true,
        alpha: 50,
        beta: -6,
        animationDurationUpdate: 10,
        area: ''
      };


      let option = {
        geo3D: {
          map: 'map',
          itemStyle: {
            borderWidth: 2, //分界线宽度
            borderColor: '#409EFF', //分界线颜色
            shadowBlur: 5,
            shadowOffsetX: 5,
            shadowOffsetY: 6
          },
          label: {
            show: true,
            alignText: 'center',
            color: '#fff', //文字颜色
            fontSize: 18, //文字大小
            borderWidth: 1.5, //分界线宽度
            borderRadius: 5,
            formatter: function (params) {
              return params.name
            }
          },
          aspectScale: 1,
          boxWidth: 120,

          // 设置单独区域样式
          regions: [],

          // hover高亮颜色
          emphasis: {
            label: {
              formatter: (params) => {
                this.area = params.name;
                return params.name
              }
            },
            itemStyle: {
              color: '#1341BE',
              opacity: 0.9, // 透明度
              borderWidth: 1, //分界线宽度
              borderColor: '#00EBFF', //分界线颜色
            },
          },
          shading: 'realistic',
          // // 真实感材质相关配置 shading: 'realistic'时有效
          realisticMaterial: {
            detailTexture: bg, // 纹理贴图
            textureTiling: 1, // 纹理平铺，1是拉伸，数字表示纹理平铺次数
            // roughness: 1, // 材质粗糙度，0完全光滑，1完全粗糙
            metalness: 0, // 0材质是非金属 ，1金属
            roughnessAdjust: 0,
            roughness: 1,
          },
          viewControl: viewControl,
        },

        series: [{
          // 类似于hover，双击地图的区块或者点击，就是通过这个传递的值
          emphasis: {
            label: {
              formatter: function (params) {
                return params.name;
              },
              show: true,
              fontSize: 13,
              fontWeight: 600,
              opacity: 1,
              textStyle: {
                backgroundColor: "transparent", // 设置 label 背景透明
                color: "#fff", // 设置 label 文字颜色
                fontFamily: "YSBTH"
              }
            },
            itemStyle: {
              color: "#15ffff",
              opacity: 1,
              borderColor: "#62def5",
              borderWidth: 5
            }
          },
        }
        ],
      };

      this.lineChart.setOption(option);
      window.addEventListener("resize", () => {
        this.lineChart.resize();
      });
      this.option = option
      //  监听
      this.lineChart.getZr().on("click", params => {
        let isinside = document.getElementById("lineChart").children[0].style.cursor
        if (this.area !== '' && isinside == "pointer") {
          option.geo3D.regions = [{
            name: this.area,
            itemStyle: {
              color: '#1058EF', // 背景颜色
              borderColor: "#fff",
              borderWidth: 1, // 边框宽度
              shadowBlur: 20, // 阴影泛化程度
              fontize: 28,
              // borderWidth: 0, //描边线宽。为 0 时无描边
              // shadowOffsetX: 4, //阴影水平方向上的偏移距离
              // shadowOffsetY: 10, //阴影垂直方向上的偏移距离
              opacity: 1,
            },
            label: {
              show: true
            },
          }]
          this.lineChart.setOption(option);
          this.$emit('customEvent', this.area);
        }
      })
    },
  }
};
</script>

<style>
body,
html {
  padding: 0;
  margin: 0;
}

#map3decharts {
  width: 1054px;
  height: 658px;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-48%);
  /* left: -30px; */
}

#lineChart {
  width: 100%;
  height: 100%;
}
</style>